import { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import BreadCrumb from "../../Components/BreadCrumb";
import Spinner from "../../Components/Spinner";
import { useGetFooterNavPageQuery } from "../../../../redux/services/internal/apiHome";

const TendersPage = ({ benchId }) => {
  const menuPageId = 1;
  const pageTitle = "Tender / Notices";

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const { data, isLoading, isError } = useGetFooterNavPageQuery({
    benchId,
    menuPageId,
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const tenderdocuments = [...(data?.data || [])]
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    .map((item) => ({
      ...item,
      tender_date: item.tender_date
        ? item.tender_date.split("-").reverse().join("-")
        : "-",
      end_date: item.end_date
        ? item.end_date.split("-").reverse().join("-")
        : "-",
    }));

  const totalPages = Math.ceil(tenderdocuments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = tenderdocuments.slice(startIndex, endIndex);

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching data!</div>;
  }

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title={pageTitle} />
        <div className="chairman-detail my-4">
          <div className="container">
            <div className="table-responsive">
              <Table striped bordered hover className="custom-table">
                <thead>
                  <tr>
                    <th>S. No.</th>
                    <th>Title</th>
                    <th className="no-wrap">Start Date</th>
                    <th className="no-wrap">End Date</th>
                    <th>Documents</th>
                  </tr>
                </thead>
                <tbody>
                  {tenderdocuments.length > 0 ? (
                    currentData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{startIndex + index + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.tender_date}</td>
                        <td>{item.end_date}</td>
                        <td className="text-center">
                          {item.logo_hidden_images ? (
                            <a
                              target="_blank"
                              href={item.logo_hidden_images}
                              rel="noopener noreferrer"
                            >
                              <i className="fas fa-file-pdf"></i>
                            </a>
                          ) : (
                            "No Document"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5">No Record Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <div className="pagination-controls">
                <button
                  onClick={() => goToPage(1)}
                  disabled={currentPage === 1}
                >
                  First
                </button>
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => goToPage(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
                <button
                  onClick={() => goToPage(totalPages)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Last
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TendersPage;
